import { InputRef } from 'antd';
import React, { forwardRef } from 'react';
import AppTextField from './AppTextField';
import type { ComponentProps } from 'react';

const MAX_SEARCH_LENGTH = 255;

type SearchTextFieldProps = Omit<ComponentProps<typeof AppTextField>, 'maxLength'>;

/**
 * SearchTextField — AppTextField with a built-in 255-character limit.
 * Blocks input beyond the limit and auto-trims on paste.
 */
const SearchTextField = forwardRef<InputRef, SearchTextFieldProps>(
  ({ onChange, ...rest }, ref) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
      if (e.target.value.length > MAX_SEARCH_LENGTH) {
        e.target.value = e.target.value.slice(0, MAX_SEARCH_LENGTH);
      }
      onChange?.(e);
    };

    return (
      <AppTextField
        ref={ref}
        maxLength={MAX_SEARCH_LENGTH}
        onChange={handleChange}
        {...rest}
      />
    );
  }
);

SearchTextField.displayName = 'SearchTextField';

export default SearchTextField;
